module.exports = __webpack_public_path__ + "img/stickers-notification-saisie.be8bda56.jpg";